import { Itemset } from "../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../store/viewmodels/TaskViewModel";
import { ItemsetResult } from "../../../store/viewmodels/ItemsetViewModel";
import { getNextUrl, postCheck } from "../../../utils/TaskNavigationServices";
import { getElementsByFiles } from "../../../utils/TaskContentServices";
import { useAppDispatch, useAppSelector } from "../../../store/Hooks";
import { StudentData } from "../../../store/viewmodels/StudentViewModel";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, setStartTime, setEndTime, resetAsSliceState } from "../../../store/AnswerSetSlice";
import React from "react";
import { Answer } from "../../../store/viewmodels/AnswerViewModel";
import { useHistory } from "react-router-dom";
import ModalWrapper from "../../utils/modal/ModalWrapper";
import FeedBack from "./FeedBack";
import Header from "./Header";


export interface StudentFindErrorItemProps {
    task: Task,
    itemset: Itemset,
    item: Item
}

function StudentFindErrorItem(props: StudentFindErrorItemProps) {
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    let aStartTime = new Date();
    const history = useHistory();

    const [isModalVisible, setModalVisible] = React.useState(false);
    const [content, setContent] = React.useState(<></>);
    const [answerValue, setAnswerValue] = React.useState(-1);
    const [clear, setClear] = React.useState(false);
    const [forward, setForward] = React.useState(false);

    const showModal = () => {
        return; // backdropclick do nothing
    }

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (clear) {
            setAnswerValue(-1);
            setClear(false);
        }
    }, [clear])

    React.useEffect(() => {
        if (answerValue !== -1) {
            setForward(true);
        } else setForward(false);
    }, [answerValue]);

    const commitAnswer = () => { //This type of implementation is required for ItemSets with multiple layers of Items
        let correct = props.item.correct;
        let answerV = answerValue === 0 ? "false" : "true";
        let noFeedBack = props.task.no_feedback;
        let time = noFeedBack ? 0 : 1500;

        if (!noFeedBack) {
            let feedBack = answerV === correct ? <FeedBack correct={true} itemId={props.item.id} /> : <FeedBack correct={false} itemId={props.item.id} />;
            setContent(feedBack);
            setModalVisible(true);
        }

        setTimeout(() => {
            setModalVisible(false);
            history.push(nextUrl.toString())

            let answer: Answer = {} as Answer;
            let aEndTime = new Date();
            answer.item = props.item.id;
            answer.value = answerV;
            answer.end_time = aEndTime.toISOString();
            answer.start_time = aStartTime.toISOString();
            dispatch(addAnswerToSet(answer));
            const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
            if (postAnswerSetCheck) {
                let asEndTime = new Date();
                dispatch(setEndTime(asEndTime.toISOString()));
                dispatch(postAnswerSet())
                    .then(() => {
                        dispatch(resetAsSliceState());
                    })
            }
        }, time);
    }

    let nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets)

    let files = getElementsByFiles(props.item);
    let taskComponent: JSX.Element = <div></div>;

    if (files.length > 1) {
        taskComponent = (
            <div className="flex justify-center m-auto items-center sm:max-w-4/5 3xl:max-w-9/10">
                <div className="flex max-h-full max-w-full mx-2 p-2">
                    <div className="flex m-auto max-w-full overflow-hidden rounded-2xl ring-teal-500 ring-4 lg:ring-8 bg-teal-500">
                        {files[0]}
                    </div>
                </div>
                <div className="flex max-h-full max-w-full mx-2 p-2">
                    <div className="flex m-auto max-w-full overflow-hidden rounded-2xl ring-teal-500 ring-4 lg:ring-8 bg-teal-500">
                        {files[1]}
                    </div>
                </div>
            </div>);
    }
    else if (files.length === 1) {
        taskComponent = (
            <div className="flex justify-center my-auto mx-auto max-w-2/5 md:max-w-1/2 lg:max-w-2/3 4xl:w-3/4">
                <div className="flex max-w-full overflow-hidden rounded-2xl place-content-center ring-teal-500 ring-4 lg:ring-8 bg-teal-500">
                    {files[0]}
                </div>
            </div>

        );
    }

    return (
        <div className="h-fit w-fit">
            <ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"feedBack"} />
            <div className="h-5/6 justify-center my-auto pt-2">
                <div className="w-full h-5/6 flex justify-center my-auto">
                    {taskComponent}
                </div>
                <div className="h-1/6 pt-2 mt-2">
                    <Header setClear={setClear} commitAnswer={commitAnswer} goForward={forward} type={"findError"} setAnswerValue={setAnswerValue} answerValue={answerValue} />
                </div>
            </div >
        </div >
    );
}

export default StudentFindErrorItem;
